import VueRouter from "vue-router";
import router from "@/router/index";

let callback;

export function handleError(e) {
  console.log("handling error", e);
  const slug =
    (e.response && e.response.data && e.response.data.error) || e.slug;
  if (slug) {
    if (slug === "token-validation-failed") {
      router.push("login");
      localStorage.removeItem("token");
      callback &&
        callback("Je bent om veiligheidsredenen uitgelogd. Log opnieuw in!");
      return;
    }
    if ((slug = "user-not-active")) {
      router.push("login");
      callback &&
        callback(
          "Deze gebruiker is niet actief. Neem gebruik op met de beheerder om geactiveerd te worden."
        );
      return;
    }
  }
  if (e.code === "ERR_NETWORK") {
    callback(
      "Kan geen verbinding maken met de server. Controleer of er een internetverbinding is. Als dit probleem blijft, neem dan contact op met de beheerder.",
      "error",
      7
    );
    return;
  }
  callback(e.message, "error");
  console.log("handle ERROR", e);
}

export function setErrorMessageCallback(cb) {
  callback = cb;
}

export default handleError;
